export enum GATEWAY {
  INOVIO_PAY = 'inoviopay',
  ROCKET_GATE = 'rocketgate',
}
